import { Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { logo } from "../utils/constants";
import SearchBar from "./SearchBar";

const handleClick = () => {
    window.location.pathname = '/';
    document.title = 'Watch More | Infinite Entertainment';
    document.querySelector('meta[property="og:title"]').setAttribute('content', 'Watch More | Infinite Entertainment');
    document.querySelector('meta[name="description"]').setAttribute('content', 'Experience limitless fun with Watch More. Stream content that fascinates and inspires. Dive into Watch More today.');
    document.querySelector('meta[property="og:description"]').setAttribute('content', 'Experience limitless fun with Watch More. Stream content that fascinates and inspires. Dive into Watch More today.');
};

const Navbar = () => (
  <Stack
    direction="row"
    alignItems="center"
    p={2}
    sx={{
      position: "sticky",
      background: "#edb818",
      top: 0,
      justifyContent: "space-between"
    }}
  >
    <Link style={{ display: "flex", alignItems: "center" }} onClick={handleClick}>
      <img src={logo} alt="logo" height={45} />
    </Link>
    <SearchBar />
  </Stack>
);

export default Navbar;
